/**
 * MessageTime Component
 * Timestamp del messaggio
 */

import { memo, useMemo } from 'react';

interface MessageTimeProps {
  timestamp: Date;
  isOutbound?: boolean;
  className?: string;
}

export const MessageTime = memo(function MessageTime({
  timestamp,
  isOutbound = false,
  className = '',
}: MessageTimeProps) {
  const timeString = useMemo(() => {
    return timestamp.toLocaleTimeString('it-IT', {
      hour: '2-digit',
      minute: '2-digit',
    });
  }, [timestamp]);

  const colorClass = isOutbound ? 'text-[#667781] dark:text-[#8696A0]' : 'text-[#787774]';

  return (
    <span className={`text-[10px] ${colorClass} ${className}`}>
      {timeString}
    </span>
  );
});
